<ct-lib-modal
  #modal
  [medium]="!largeModal()"
  [big]="largeModal()"
  [hideFooter]="true"
  [label]="'jobboard.platform.jobs.applications.complete-title' | transloco"
>
  @if (application(); as current) {
    <form class="complete-form" [formGroup]="form" (ngSubmit)="submit()">
      <ct-lib-inline-info>
        <p>
          {{
            'jobboard.platform.jobs.applications.complete-intro'
              | transloco: { job: current.jobTitle, company: current.companyName }
          }}
        </p>
      </ct-lib-inline-info>

      @if (isMissing(PlatformMissingDataType.SALARY)) {
        <div
          class="form-group form-floating"
          [class.invalid]="form.controls['salary'].invalid && submitAttempt()"
        >
          <ct-lib-salary-input
            [control]="salaryControl()"
            currencyCode="EUR"
            [placeholder]="
              'jobboard.platform.jobs.applications.complete-fields.salary' | transloco
            "
          ></ct-lib-salary-input>
          @if (form.controls['salary'].invalid && submitAttempt()) {
            <div class="validation">
              <p>{{ 'ct-library.validation.required' | transloco }}</p>
            </div>
          }
        </div>
      }

      @if (isMissing(PlatformMissingDataType.START_DATE) && formNonce()) {
        <div
          class="form-group"
          [class.invalid]="form.controls['startDate'].invalid && submitAttempt()"
        >
          <app-date-input
            [control]="startDateControl()"
            [submitAttempt]="submitAttempt()"
            [placeholder]="
              'jobboard.platform.jobs.applications.complete-fields.start-date' | transloco
            "
          ></app-date-input>
          @if (form.controls['startDate'].invalid && submitAttempt()) {
            <div class="validation">
              <p>{{ 'ct-library.validation.required' | transloco }}</p>
            </div>
          }
        </div>
      }

      @if (isMissing(PlatformMissingDataType.DOCUMENTS)) {
        <div class="section">
          <h5>
            {{ jobs.missingDataTranslationKey(PlatformMissingDataType.DOCUMENTS) | transloco }}
          </h5>
          <div class="row">
            <div class="col-12 col-md-6">
              <ct-lib-file-input
                [control]="cvControl()"
                [multiple]="false"
                [accept]="fileTypes"
                [showAcceptLabel]="false"
                [submitAttempt]="submitAttempt() && form.hasError('documents')"
                [label]="'jobboard.platform.jobs.applications.complete-fields.cv' | transloco"
              ></ct-lib-file-input>
            </div>
            <div class="col-12 col-md-6">
              <ct-lib-file-input
                [control]="certificatesControl()"
                [multiple]="true"
                [accept]="fileTypes"
                [showAcceptLabel]="false"
                [submitAttempt]="submitAttempt() && form.hasError('documents')"
                [label]="'jobboard.platform.jobs.applications.complete-fields.certificates' | transloco"
              ></ct-lib-file-input>
            </div>
          </div>
          @if (form.hasError('documents') && submitAttempt()) {
            <p class="validation-text">{{ 'ct-library.validation.required' | transloco }}</p>
          }
        </div>
      }

      @if (isMissing(PlatformMissingDataType.SKILLS)) {
        <div
          class="section"
          [class.invalid-section]="form.controls['skills'].invalid && submitAttempt()"
        >
          <h5>
            {{ jobs.missingDataTranslationKey(PlatformMissingDataType.SKILLS) | transloco }}
          </h5>
          <app-platform-profile-skills
            [form]="form"
            (duplicateSkill)="onDuplicateSkill()"
          ></app-platform-profile-skills>
          @if (form.controls['skills'].invalid && submitAttempt()) {
            <p class="validation-text">{{ 'ct-library.validation.required' | transloco }}</p>
          }
        </div>
      }

      @if (isMissing(PlatformMissingDataType.ISA) && formNonce()) {
        <div
          class="section"
          [class.invalid-section]="form.controls['isa'].invalid && submitAttempt()"
        >
          <h5>
            {{ jobs.missingDataTranslationKey(PlatformMissingDataType.ISA) | transloco }}
          </h5>
          <p class="text-muted isa-info">
            {{ 'jobboard.platform.jobs.applications.complete-fields.isa-info' | transloco }}
          </p>
          <app-skill-test
            [control]="isaControl()"
            [submitAttempt]="submitAttempt()"
          ></app-skill-test>
        </div>
      }

      <div class="footer-actions">
        <app-button variant="white-grey" htmlType="button" (click)="close()">
          {{ 'jobboard.platform.jobs.applications.complete-cancel' | transloco }}
        </app-button>
        <app-button variant="primary" htmlType="submit">
          {{ 'jobboard.platform.jobs.applications.complete-submit' | transloco }}
        </app-button>
      </div>
    </form>
  }
</ct-lib-modal>
